import { render } from "./AchievementRing.vue?vue&type=template&id=01ad7d3a&scoped=true"
import script from "./AchievementRing.vue?vue&type=script&lang=js"
export * from "./AchievementRing.vue?vue&type=script&lang=js"

import "./AchievementRing.vue?vue&type=style&index=0&id=01ad7d3a&lang=css"
import "./AchievementRing.vue?vue&type=style&index=1&id=01ad7d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ad7d3a"]])

export default __exports__